<template>
  <div>
    <div class="loading-container" v-if="isLoading">
      <loading-overlay></loading-overlay>
    </div>
    <transition name="fade" mode="out-in">
      <div class="pages-container" v-show="!isLoading">
        <div v-if="model.id">
            <div v-if="isModelFullPage">
              <view-offering-page />
            </div>
            <div v-else>
              <view-content-page />
            </div>
        </div>
      </div>
    </transition>
  </div>
</template>


<script>
import LoadingOverlay from "@/components/LoadingOverlay";
import ContentPageMixin from "../mixins/ContentPageMixin";
import ViewOfferingPage from "@/components/ViewOfferingPage";
import ViewContentPage from "@/components/ViewContentPage";

export default {
  name: "content-page",
  components: {
    LoadingOverlay, ViewOfferingPage, ViewContentPage
  },
  mixins: [ContentPageMixin],

};
</script>

<style scoped>

.loading-container {
  min-height: 90vh;
}
.pages-container {
  background: #fff;
}


.pages-container :deep(.section-non-self-service) {
  display: none;
}

.pages-container :deep(p),
.pages-container :deep(span) {
  z-index: 20 !important;
}

.pages-container :deep(h1) {
  font-size: 26px !important;
  line-height:1.5 !important;
  font-family: artifaktElementRegular !important;
  color: #000000 !important;
}

.pages-container :deep(a[id]),
.pages-container :deep(a[name]) {
  padding-top: 10vh;
}

.pages-container :deep(h2) {
  font-size: 26px !important;
  line-height:1.5 !important;
  font-family: artifaktElementBold !important;
  color: #000000 !important;
}

.pages-container :deep(h3) {
  font-size: 20px !important;
  line-height:1.5 !important;
  font-family: artifaktElementBold !important;
  color: #000000 !important;
}

.pages-container :deep(p) {
  font-size: 16px !important;
  font-family: artifaktElementRegular !important;
  color: #000000 !important;
}

.overview-text span {
  font-size: 16px;
  font-weight: bold;
  color: #000000;
}

.container {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}
.pages-container :deep(a) {
  color: var(--link-color) !important;
}

.pages-container :deep(.submit-btn:hover) {
    color: #fff !important;
    background: var(--secondary-color-hover) !important;
}

.pages-container :deep(a:hover),
.pages-container :deep(a:hover > *),
.pages-container :deep(a:hover > strong > *) {  
  text-decoration: underline !important;
  cursor: pointer;
}
.main-panel {
  box-shadow: none !important;
}
@media (min-width: 576px) {
  .container {
    max-width: 540px;
  }
}
@media (min-width: 768px) {
  .container {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
  .container {
    max-width: 960px;
  }
}
@media (min-width: 1200px) {
  .container {
    max-width: 1140px;
  }
}

  @media screen and (min-width: 801px) {
    .pages-container :deep(.rel-container) {
      margin-bottom: 0 !important;
    }
  } 
  @media screen and (min-width: 4000px) {
    .pages-container :deep(.rel-container) {
      margin-bottom: 15px !important;
    }
  }

</style>